import { createId } from "@paralleldrive/cuid2";
import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";

import { LocalStorageKey } from "@/constants/shared";

export const useDeviceId = () => {
  const [deviceId, setDeviceId] = useLocalStorage<string>(
    LocalStorageKey.PlumeDeviceId,
    "",
  );

  useEffect(() => {
    if (!deviceId) {
      const newId = createId();
      setDeviceId(newId);
    }
  }, [deviceId, setDeviceId]);

  return deviceId;
};

export const initDeviceId = () => {
  const existingId = localStorage.getItem(LocalStorageKey.PlumeDeviceId);
  if (!existingId) {
    const newId = createId();
    localStorage.setItem(LocalStorageKey.PlumeDeviceId, newId);
    return newId;
  }
  return existingId;
};
